export default "__VITE_ASSET__DF$UdXXr__"